import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import VPCHero from './components/VPCHero';
import SubscriptionPlans from './components/SubscriptionPlans';
import BenefitsSection from './components/BenefitsSection';
import HowItWorksSection from './components/HowItWorksSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';

const VirtualPrimaryCare: React.FC = () => {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <main>
        <VPCHero />
        <BenefitsSection />
        <SubscriptionPlans />
        <HowItWorksSection />
        <TestimonialsSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default VirtualPrimaryCare;